import {
  DELETE_SERVER_SIDE_ASYNC,
  DISABLE_MAILBOX_ASYNC,
  MAILBOX_REQUEST_ASYNC,
  SERVER_SIDE_REQUEST_ASYNC,
  UPDATE_MAILBOX_ASYNC,
  UPDATE_SERVER_SIDE_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
    mailboxData: {},
    exchangeError: null,
    mailboxError: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SERVER_SIDE_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: !action.payload.silent,
          mailboxError: null,
          exchangeError: null,
        }
      case SERVER_SIDE_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
          exchangeError: null,
        }
      case SERVER_SIDE_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case SERVER_SIDE_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_SERVER_SIDE_ASYNC.INITIATE:
        return { ...state, loader: true, mailboxError: null }
      case UPDATE_SERVER_SIDE_ASYNC.ERROR:
        return { ...state, loader: false }
      case MAILBOX_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, mailboxError: false }
      case MAILBOX_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          mailboxData: action.payload.data,
          loader: false,
        }
      case UPDATE_MAILBOX_ASYNC.INITIATE: {
        const newData = state.mailboxData
        newData['911'] = action.payload.value
        return { ...state, loader: true, mailboxData: newData }
      }
      case UPDATE_MAILBOX_ASYNC.SUCCESS:
        return {
          ...state,
          mailboxData: action.payload.data,
          loader: false,
        }
      case UPDATE_MAILBOX_ASYNC.ERROR:
        return {
          ...state,
          mailboxError: action.error.response,
          loader: false,
          mailboxData: { ...state.mailboxData, 911: null },
        }
      case DELETE_SERVER_SIDE_ASYNC.INITIATE:
        return { ...state, mailboxError: null }
      case DISABLE_MAILBOX_ASYNC.INITIATE:
        return { ...state, loader: true, mailboxError: false }
      case DISABLE_MAILBOX_ASYNC.SUCCESS: {
        const newData = state.mailboxData
        newData['911'] = null
        return { ...state, loader: false, mailboxData: newData }
      }
      case DISABLE_MAILBOX_ASYNC.ERROR:
        return { ...state, mailboxError: action.error.detail, loader: false }
      default:
        return state
    }
  }
}
